<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class SimpleTourPageMixin extends Vue {
        async loadRuntimeData() {
            if (
                !!this.$conf.public.searchWithoutDestination?.countryId &&
                simpleTourRuntimeStore.country.id !== this.searchRequest.countryId
            ) {
                await simpleTourRuntimeStore.loadCountry(this.searchRequest.countryId)
            }
            if (this.searchRequest.cityId && simpleTourRuntimeStore.city.id !== this.searchRequest.cityId)
                await simpleTourRuntimeStore.loadCity(this.searchRequest.cityId)
        }
    }

    export default SimpleTourPageMixin
</script>
